/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_HeadingInputs */

const en_visa_eb5_heading = /** @type {(inputs: Visa_Eb5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core EB-5 Considerations`)
};

const pt_visa_eb5_heading = /** @type {(inputs: Visa_Eb5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Considerações Centrais do EB-5`)
};

const es_visa_eb5_heading = /** @type {(inputs: Visa_Eb5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consideraciones Centrales del EB-5`)
};

/**
* | output |
* | --- |
* | "Core EB-5 Considerations" |
*
* @param {Visa_Eb5_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_heading = /** @type {((inputs?: Visa_Eb5_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_heading(inputs)
	if (locale === "es") return es_visa_eb5_heading(inputs)
	return en_visa_eb5_heading(inputs)
});